import { render } from "./StatusAlertMessage.vue?vue&type=template&id=70778126"
import script from "./StatusAlertMessage.vue?vue&type=script&lang=js"
export * from "./StatusAlertMessage.vue?vue&type=script&lang=js"

import "./StatusAlertMessage.vue?vue&type=style&index=0&id=70778126&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__